import { useContext } from "react";
import { I18nContext } from "./I18nProvider";

// Hook for function components: const { t, locale, setLocale } = useTranslation();
export function useTranslation() {
   return useContext(I18nContext);
}

export default useTranslation;
